<template>
<div>
  <app-breadcrumb />
  <p style="font-size:3px ">*The consignee and buyer information can be modified in the Invoice column under Order Inquiry.</p>
  <br>
  <div style="margin-top: 20px;text-align: right;margin-right: 20px">
    <el-button size="small" @click="BtnPrint()">Print</el-button>
    <el-button size="small" @click="DownLoad()">DownLoad</el-button>
  </div>
  <div id="print_Id">
        <table>
          <thead>
          <tr>
            <th colspan="2" style="text-align: center;border:none">Tax Invoice</th>
            <th colspan="1" style="text-align: right;border:none">(ORIGINAL FOR RECIPENT)</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td rowspan="3" style="width:50%">
              <p v-if="poOrder.agentNo ==='INA80903997'">
                Soyie Enterprices
                <br>
                271 Lane 17 Duncan Bosti ,Duncan Bosti Dimapur
                <br>
                Nagaland - 797112
                <br>
                GSTIN/UIN  : 13ADAPL3973E1ZV
                <br>
                State Name : Nagaland, Code : 13
                <br>
                Contact    : 9436600918
                <br>
                E-Mail     : ABENILOTHA82448@GMAIL.COM
              </p>
              <p v-else-if="poOrder.agentNo === 'INA80307869'">
                M/S  S S ENTERPRISES
                <br>
                FLAT NO 10F/6/G-2 GROUND CLIVE ROAD,
                <br>
                CIVIL LINES, ALLAHABAD
                <br>
                GSTIN/UIN  : 09ANLPK8393C1ZL
                <br>
                State Name : UTTAR PRADESH
                <br>
                Contact    : 9956639703 , 6306019072
                <br>
                E-Mail     : Sriajeet111@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA81302578'">
                Pappa's House Health Care
                <br>
                #3941 6th cross, 20th Main, road near hampi circle, vijaynagar 2nd Stage
                <br>
                Mysore  :- 570017
                <br>
                GSTIN/UIN  - 29BTLPJ4007K1ZF
                <br>
                State Name   - Karnataka
                <br>
                Contact   - 8749001361
                <br>
                E-Mail - pappashousehealthcare@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA81076220'">
                KHAIDEM RETAIL
                <br>
                2nd Floor Opp.Astc Parking Near Computer Clinic
                <br>
                Ulubari Gs Road Guwahati  Assam-781007
                <br>
                GSTIN/UIN  : 18BBJPS1318G5ZH
                <br>
                State Name : Assam, Code : 18
                <br>
                Contact    : 7002308701
                <br>
                E-Mail     : khaidemretail@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA83926859'">
                M/S SMS FURNITURE
                <br>
                I-2/46, KESHAVPURAM, KALYYANPUR,
                <br>
                AVAS VIKAS-1 KANPUR NAGAR, UTTAR PRADESH -208017
                <br>
                GSTIN/UIN  : 09BIYPS2347M1Z6
                <br>
                State Name : Uttar Pradesh
                <br>
                Contact    : +91 9336203168
                <br>
                E-Mail     : vsrivastava1666@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA80691786'">
                SACHI VARAHI ENTERPRISES
                <br>
                #863, ASWIN 1ST CROSS, GEETANJALI
                <br>
                LAYOUT,HAL, 3RD STAGE BENGLURU - 560075
                <br>
                GSTIN/UIN  : 29ACRPS1939D1Z4
                <br>
                State Name : SACHI VARAHI ENTERPRISES
                <br>
                Contact    : 9886636156
                <br>
                E-Mail     : SHANMUGHEM@YAHOO.COM
              </p>
              <p v-else-if="poOrder.agentNo === 'INA83056800'">
                HOLY CARE
                <br>
                HOLY CARE, PPUNNAD IRRITY, KANNUR,
                <br>
                KERALA -670703
                <br>
                GSTIN/UIN  : 32CAPPS4298M1ZS
                <br>
                State Name : HOLY CARE
                <br>
                Contact    : 4602939944,9447354944 , 9656205070
                <br>
                E-Mail     : holycareknr@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA81735990'">
                VEDAM HEALTH CARE
                <br>
                No. 173/9th Cross 4th Main 1st Stage Indiranagar
                <br>
                Bangalore Karnataka -560038
                <br>
                GSTIN/UIN  : 29AARFV4026C1Z0
                <br>
                State Name : Karnataka, Code : 29
                <br>
                Contact    : 9740846345
                <br>
                E-Mail     : vedhamhcare@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA82728817'">
                AJIT ENTERPRISE
                <br>
                Budhurail Po Jaiforpur Kathal Road Near Dps School
                <br>
                Silchar Assam-788005
                <br>
                GSTIN/UIN  : 18AXPPG1701L1ZD
                <br>
                State Name : Assam, Code : 18
                <br>
                Contact    : 7002154759
                <br>
                E-Mail     : ajitkrgoala15@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA83069158'">
                DEAR AGENCY
                <br>
                Khulem, Naoremthong Leikai Uk Road, Imphal,
                <br>
                Imphal West Manipur-795004
                <br>
                GSTIN/UIN  : 14BQTPS4832C1ZN
                <br>
                State Name : Manipur, Code : 14
                <br>
                Contact    : 7005264792
                <br>
                E-Mail     : gambhir_rk@ymail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA85988609'">
                VIJAYA HEALTH PRODUCT
                <br>
                Flat No 105 2-2-1121 Ambuja N View New
                <br>
                Nallakunta Hyderabad Telangana-500044
                <br>
                GSTIN/UIN  : 36AATPN7499K1ZI
                <br>
                State Name : Telangana, Code : 36
                <br>
                Contact    : 9705619000
                <br>
                E-Mail     : paravastu55@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA86501281'">
                POOJA ENTERPRISES
                <br>
                Apj Lubaricants,1 Basement Akash E Space
                <br>
                Dominos Pizza ,  Opp. Essar Petrol Pump Vip Road
                <br>
                Bharthana  Vesu  Surat Gujarat-395007
                <br>
                GSTIN/UIN  : 24AODPG2395F1Z7
                <br>
                State Name : Gujarat, Code : 24
                <br>
                Contact    : 9033611197
                <br>
                E-Mail     : fohowaypoojaenterprise@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA87727262'">
                THE KAMNA HEALTH PRODUCTS
                <br>
                C-163 , Jawahar Park Khanpur
                <br>
                Delhi-110062
                <br>
                GSTIN/UIN  : 07AFLPJ2103F1ZX
                <br>
                State Name :Delhi, Code : 07
                <br>
                Contact    : 9650002947
                <br>
                E-Mail     : raj.joshi2@yahoo.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA88019922'">
                AAMIT ENTERPRISES
                <br>
                Flat No 305 ,Third Floor, Plot No SB-52,, Krishna
                <br>
                Enclave, Trimurty Tonk Road, Bapu Nagar, Jaipur,
                <br>
                Rajasthan-302015
                <br>
                GSTIN/UIN  :  08BFMPS2093K1ZS
                <br>
                State Name : Rajasthan, Code : 08
                <br>
                Contact    : 9650002947
                <br>
                E-Mail     : aamitksha@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA88216113'">
                NATURAL
                <br>
                MALABAR MANOR B4, KOTTOOLI MAVOOR ROAD,
                <br>
                KOZHIKODE KERALA -673016
                <br>
                GSTIN/UIN  : 32AJOPA4317R1Z0
                <br>
                State Name : Kerala, Code : 32
                <br>
                Contact    : 9961111777
                <br>
                E-Mail     : drrazalap@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA86128155'">
                NAGPUR HEALTH PRODUCTS
                <br>
                PLOT NO-8,KOTWAL DONGA, SWAGAT NAGAR, ANANT NAGAR,NAGPUR,
                <br>
                MAHARASTHRA-440013
                <br>
                GSTIN/UIN  : 27BYKPK5586L1ZL
                <br>
                State Name : MAHARASTHRA
                <br>
                Contact    : +91 9890402565
                <br>
                E-Mail     : yogeshkadwe@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA83206610'">
                COSMIC INNOVATIONS
                <br>
                Jawan Cross Road, Edappally,
                <br>
                Cochin, Kerala -682026
                <br>
                GSTIN/UIN  : 32ARIPK8293Q1Z
                <br>
                State Name : Kerala
                <br>
                Contact    : 9070905090
                <br>
                E-Mail     : gsv121212@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA83360157'">
                UNBEATABLE WELLNESS
                <br>
                POST -PAILAN, VILLAGE -DAULATPUR,SOUTH -24-PARGANAS,
                <br>
                WEST  BENGAL-700104
                <br>
                GSTIN/UIN  : 19BRRPM3670D1ZF
                <br>
                State Name : West Bengal, Code : 19
                <br>
                Contact    : 7003079697
                <br>
                E-Mail     : israjmondal0@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA81575721'">
                Global Wellness Enterprise
                <br>
                14-15,, 3rd Cross Near Masjid-Ali, Rachenahalli Main RoadThanisandra Dr Shivaram Karnath Nagar, Bengaluru, Bengaluru
                <br>
                (Bangalore) Urban, Karnataka, 560077
                <br>
                GSTIN/UIN  : 29CGWPB3540G1Z7
                <br>
                State Name : Karnataka
                <br>
                Contact    : 9739972741
                <br>
                E-Mail     : tabassum07banu@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA83677626'">
                Eagle Enterprise
                <br>
                11/120 maqbara gwaltoli kanpur' Kanpur
                <br>
                (UP) 208001
                <br>
                GSTIN/UIN  : 09EKRPM4330JIZN
                <br>
                State Name : Uttar Pradesh
                <br>
                Contact    : +91 79051 24526
                <br>
                E-Mail     : moirfanmi1@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA80589327'">
                AFRA HEALTHCARE
                <br>
                33/557/2,LBS ROAD, CHIYYARAM PO,
                <br>
                THRISSUR, THRISSUR KERALA - 680026
                <br>
                GSTIN/UIN  : 32CCWPA4966K1Z4
                <br>
                State Name : KERALA
                <br>
                Contact    : +91 9747892804
                <br>
                E-Mail     : afrahealthcare@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA85297558'">
                MAHALAXMI TRADERS
                <br>
                37, 00, TALAB KE PASS JODHPUR,
                <br>
                RAJASTHAN - 342303
                <br>
                GSTIN/UIN  : 08AXUPR9017K1ZJ
                <br>
                State Name : Rajasthan
                <br>
                Contact    : +91 9166233834
                <br>
                E-Mail     : laxmanjakhar590@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA82879959'">
                BLUEBELLS STORE ENETERPRISES
                <br>
                KHEL I, DIPHUPAR VILLAGE, Diphupar B,
                <br>
                Dimapur,Chumoukedima, Nagaland, 797115
                <br>
                GSTIN/UIN  : 13BNNPK8314C2Z7
                <br>
                State Name : Nagaland
                <br>
                Contact    : 8414855286
                <br>
                E-Mail     : Lindakevi@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA86957970'">
                MAAMM GROUP SERVICES
                <br>
                18/397, PARAKKADAN, THAMARACHAL,
                <br>
                KIZHAKKAMBALAM, Ernakulum, Kerala, 683561
                <br>
                GSTIN/UIN  : 32AYWPA8372M1ZT
                <br>
                State Name : KERALA
                <br>
                Contact    : +91 9020401094
                <br>
                E-Mail     :  eldhoparakkattil@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA80800130'">
                SANA
                <br>
                PATTAMBI ROAD, EDAPPAL, EDAPPAL POST,
                <br>
                Malappuram, Kerala, 679576
                <br>
                GSTIN/UIN  : 32DGEPS8940E1ZA
                <br>
                State Name : KERALA
                <br>
                Contact    : +91 8893001001
                <br>
                E-Mail     : sanamobileedappal@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA82651850'">
                CHANDA AYURVEDIC PVT LTD
                <br>
                STATION ROAD.WARD NO-24 ,
                <br>
                GOPALGANJ, GOPALGANJ, BIHAR – 841428
                <br>
                GSTIN/UIN  : 10DSUPK7229E1ZN
                <br>
                State Name : BIHAR
                <br>
                Contact    : +91 9936472126
                <br>
                E-Mail     : telecom.verma@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA83213511'">
                M/S MADHURIYA ENTERPRISE
                <br>
                WARD NO-4 MILANPUR PATHSALA,C/O HIMANGSHU TALUKDAR,
                <br>
                BAJALI ASSAM -781325
                <br>
                GSTIN/UIN  : 10DSUPK7229E1ZN
                <br>
                State Name : ASSAM
                <br>
                Contact    : +91 7635999129
                <br>
                E-Mail     : medhirinkull@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA81193993'">
                MAGANDHA ENTERPRISES
                <br>
                SHOP NO-FF-18, RAHUL BAZAR, BEHIND SONCHAFA,JEWELLERS,
                <br>
                SITABURDI, NAGPUR, Nagpur,Maharashtra, 440012
                <br>
                GSTIN/UIN  : 27AWVPB0269P2ZT
                <br>
                State Name : Maharashtra
                <br>
                Contact    : +91 9730619866
                <br>
                E-Mail     : alka@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA88711883'">
                Health Harmony
                <br>
                GROUND FLOOR.45-653,DELTA TOWER, THALASSERY ROAD,
                <br>
                KANNUR ,KANNUR KERALA-670012
                <br>
                GSTIN/UIN  : 32ANMPC7673G1ZY
                <br>
                State Name : KERALA
                <br>
                Contact    : +91 7306999165
                <br>
                E-Mail     : ckmidun@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA85666830'">
                Priya Enterprises
                <br>
                H No-237/22,Kothiyad Civil Lines,Bulandsahar ,
                <br>
                Uttar Pradesh-203001
                <br>
                GSTIN/UIN  : 09BRHPG7943P1ZZ
                <br>
                State Name : UTTAR PRADESH
                <br>
                Contact    : +91 9358010121
                <br>
                E-Mail     : vibhorgoel7@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA80595762'">
                VINO ENTERPRISE
                <br>
                UPPER CHANDMARI COLONY NEAR HOME GUARD OFFICE KOHIMA
                <br>
                GSTIN/UIN  : 13ABQPZ0518F1ZK
                <br>
                State Name :  NAGALAND
                <br>
                Contact    : +91 8794170386
                <br>
                E-Mail     : noulevinuo23@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA81626303'">
                Skymorn Herbs And Dyes Exports
                <br>
                SHIVPURI, 1075, NH-24 BYE PASS, NEAR SRI KRISHAN INTER COLLAGE,
                <br>
                GAZIABAD, Ghaziabad, Uttar Pradesh, 201009
                <br>
                GSTIN/UIN  : 09CIYPG4640N1ZF
                <br>
                State Name :  Uttar Pradesh
                <br>
                Contact    : +91 9999460543
                <br>
                E-Mail     : skymorn@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA87179169'">
                WELL LIFE
                <br>
                9/395 F , HIBA TOWER, TIPPU SULTHAN ROAD,
                <br>
                WDAVANNA MALAPPRAM -676541
                <br>
                GSTIN/UIN  : 32BMYPA7243N1ZK
                <br>
                State Name :  Kerala
                <br>
                Contact    : 9847460553
                <br>
                E-Mail     : gafoorga4712@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA81235361'">
                JOHN LALBIAKHLUNA
                <br>
                53 MV- MISSION VENG BAZAR, AIZWAL,
                <br>
                MIZORAM - 796005
                <br>
                GSTIN/UIN  :  Pending
                <br>
                State Name :  MIZORAM
                <br>
                Contact    :  9436157682
                <br>
                E-Mail     : jibhluna@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA87076392'">
                KHALSA STORES
                <br>
                KHALSA STORES, , NEAR ROHI BRIDGE,
                <br>
                TARN TARAN, Tarn Taran, Punjab,143401
                <br>
                GSTIN/UIN  : 03AFVPS0092Q1ZN
                <br>
                State Name :  PUNJAB
                <br>
                Contact    : 7009842847 , 9855783707
                <br>
                E-Mail     : Bhagwansinghkhalsaji@gmail.com
              </p>
              <p v-else-if="poOrder.agentNo === 'INA86665570'">
                MATTEI SPAGYRIC BIOSCIENCE PRIVATE LIMITED
                <br>
                GROUND FLOOR, 9197 , BLOCK J, Aerocity, Mohali Airport, Road, Kissan Vikas Chamber Punjab,
                <br>
                Aerocity, Mohali, SAS, Nagar, Punjab, 140306
                <br>
                GSTIN/UIN  : 03AAMCM1006D2Z5
                <br>
                State Name :  PUNJAB
                <br>
                Contact    : 9779881010 , 9779881090
                <br>
              </p>
              <p v-else>
                FOHOWAY INDIA PRIVATE LIMITED
                <br>
                Premises No. DJ1001, 1002, 1023, 1024 , 10th Floor
                <br>
                DLF Tower B, Jasola South West Delhi-110025
                <br>
                GSTIN/UIN             : 07AADCF9402B1Z2
              </p>
            </td>
            <td style="width:25%">
              Invoice No.{{this.listQuery.Invoice }}
              <br>
              GST-00
              <p>			</p>
            </td>
            <td style="width:25%">Dated<br><p>{{this.listQuery.createTime2}}</p></td>
          </tr>
          <tr>
            <td>
              Delivery Note
              <br>
              <p>			</p>       <!-- 发货备注，内容可以为空 -->
            </td>
            <td>
              Mode/Terms of Payment
              <br>
              <p>			</p>  			<!-- 支付方式，内容可以为空 -->
            </td>
          </tr>
          <tr>
            <td>Supplier's Ref<br><!-- 标题1，内容可以为空 --> <p>			</p>  </td>
            <td>Other Reference(s)<br><!-- 标题2，内容可以为空 --> <p>			</p>  </td>
          </tr>
          <tr>
            <td rowspan="3" style="width:50%">
              <!--                  <%--收货人信息--%>-->
              Consignee (Ship to)
              <br>
              <!--                  <%--编号姓名--%>-->
              {{this.poOrder.recCode}}/{{this.poOrder.recName}}
              <br>
              <!--                  <%--收货地址--%>-->
              {{this.poOrder.recAddr}}
              <br>
              <!--                  <%--区/市--%>-->
              {{this.listQuery.addressq}}
              <br>
              <!--                  <%--邦名 编码--%>-->
              {{this.listQuery.regionName }} -{{this.poOrder.zipCode}}
              <br>
              <!--                  <%--税号--%>-->
              GSTIN/UIN           : {{this.poOrder.gstNo}}
              <br>
              <!--                  <%--邦名--%>-->
              State Name        : {{this.listQuery.regionName }}, Code :
<!--              <fh:code listCode="in.addr.code" value="${region_name }"></fh:code>-->
              <br>
              <!--                  <%--收货人电话--%>-->
              Contact    :{{this.poOrder.recPhone}}
              <br>
              <!--                  <%--email--%>-->
              E-Mail     :
            </td>
            <td>Buyer's Order No.<br>{{this.poOrder.orderNo}}</td>
            <td>Dated<br><p>{{this.listQuery.createTime2}}</p></td>
          </tr>
          <tr>
            <td>Despatch Document No.<br><p>			</p></td>
            <td>Delivery Note Date<br><p>			</p></td>
          </tr>
          <tr>
            <td>Despatch through<br><p>			</p></td>
            <td>Destination<br><p>			</p></td>
          </tr>
          <tr>
            <td rowspan="3" style="width:50%">
              Buyer (Bill to)
              <br>
              {{this.poOrder.memberNo}}/{{this.miMember.name}}
              <br>
              {{this.miMember.storeAddr}}
              <br>
              <!--                  <%--区/市--%>-->
              {{this.listQuery.addressqben}}
              <br>
              <!--                  <%--邦名 编码--%>-->
              {{this.listQuery.benbang }} -{{this.miMember.storePost}}
              <br>
              GSTIN/UIN             :
              {{this.miMember.gstNo}}
              <br>
              State Name           :{{this.listQuery.benbang }}, Code :
<!--              <fh:code listCode="in.addr.code" value="${benbang }"></fh:code>-->
              <br>
              Contact            :
              {{this.miMember.mobile}}
              <br>
              E-Mail     :
              {{this.miMember.email}}
            </td>
            <td colspan="3"  valign="top">Terms of Delivery<br><p>			</p></td>
          </tr>
          </tbody>
        </table>
<!--     -------------------------------------------------------------------------------  --><table class="table " style="width: 100%;">

    <thead>
    <tr>
      <th>Sl No</th>
      <th>Particulars</th>
      <th>HSN/SAC</th>
      <th>GST Rate</th>
      <th>Qty</th>
      <th>Rate</th>
      <th>per</th>
      <th>Amount</th>
    </tr>
    </thead>
    <tbody>
          <tr  v-for="(d,index) in Listdetails" :key="d.id">
              <td> {{index+1}}</td>
              <td> {{d.name}}</td>
              <td> {{d.HSN_CODE}}</td>
              <td> {{d.GET_RATE}}%</td>
              <td> {{d.quantity}}</td>
              <td> {{d.RateStandardPrice }}</td>
              <td><p>		</p></td>
              <td>{{d.AllTotalprice }}</td>
          </tr>
    <tr>
      <td></td>
      <td></td>
      <td> </td>
      <td> </td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td></td>
      <td></td>
      <td> </td>
      <td> </td>
      <td></td>
      <td></td>
      <td></td>
      <td> {{this.listQuery.AmountTotal }}</td>
    </tr>
    <tr>
      <td></td>
      <td>IGSTTotal</td>
      <td> </td>
      <td> </td>
      <td></td>
      <td></td>
      <td></td>
      <td>-</td>
    </tr>
    <tr>
      <td></td>
      <td>CGSTTotal</td>
      <td> </td>
      <td> </td>
      <td></td>
      <td></td>
      <td></td>
      <td>{{this.listQuery.CGSTTotal }}</td>
    </tr>
    <tr>
      <td></td>
      <td>SGSTTotal</td>
      <td> </td>
      <td> </td>
      <td></td>
      <td></td>
      <td></td>
      <td>{{this.listQuery.SGSTTotal }}</td>
    </tr>
    <tr>
      <td></td>
      <td>Round Off</td>
      <td> </td>
      <td> </td>
      <td></td>
      <td></td>
      <td></td>
      <td>{{this.listQuery.RoundOff }}</td>
    </tr>
    <tr>
      <td></td>
      <td>Total</td>
      <td> </td>
      <td> </td>
      <td></td>
      <td></td>
      <td></td>
      <td>{{this.listQuery.RateTotal }}</td>
    </tr>
    <tr>
      <td colspan="7" style="text-align: left;">Amount Chargeable (in words) &nbsp;&nbsp; </td>
      <td>E. & O.E</td>
    </tr>
    <tr>
      <td colspan="8" style="text-align: left;">INR&nbsp;{{this.listQuery.RateTotalEn}} &nbsp;ONLY</td>
    </tr>
    <tr><td colspan="8"><p>	</p></td></tr>
    </tbody>
  </table>
<!--    ------------------------------------------------------------------------  -->
    <table  class="table" style="width: 100%;">
      <thead>
      </thead>
      <tbody>
        <tr>
          <td rowspan="2"  style="width:200px;">HSN/SAC</td>
          <td rowspan="2" >Taxable Value</td>
          <td colspan="2">IGST</td>
          <td colspan="4"></td>
          <td rowspan="2">Total Tax Amount</td>
        </tr>
        <tr>
          <td colspan="2"></td>

          <td colspan="2">CGST</td>

          <td colspan="2">SGST</td>
        </tr>
        <tr v-for="h in ListHSN" :key="h.index">
          <td >{{h.HSNSAC}}</td>
          <td>{{h.TaxableValue}}</td>
          <td>0</td>
          <td>0</td>
          <td>{{h.CGST1}}%</td>
          <td>{{h.CGST2}}</td>
          <td>{{h.SGST1}}%</td>
          <td>{{h.SGST2}}</td>
          <td>{{h.TotalTaxAmount}}</td>
        </tr>
        <tr>
          <td >Total</td>
          <td>{{HSNTotal.TotalTaxableValue}}</td>
          <td colspan="2">0</td>
          <td colspan="2">{{HSNTotal.TotalTaxCGST}}</td>
          <td colspan="2">{{HSNTotal.TotalTaxSGST}}</td>
          <td>{{HSNTotal.TotalTaxTotalTaxAmount}}</td>
        </tr>
        <tr>
          <td colspan="9"><p>	</p></td>
        </tr>
        <tr>
          <td colspan="9" style="text-align: right;">
            <p v-if="poOrder.agent === 'INA80903997'">Soyie Enterprices</p>
            <p v-else-if="poOrder.agent === 'INA81076220'">KHAIDEM RETAIL</p>
            <p v-else-if="poOrder.agent === 'INA81302578'">Pappa's House Health Care</p>
            <p v-else-if="poOrder.agent === 'INA80307869'">M/S  S S ENTERPRISES</p>
            <p v-else-if="poOrder.agent === 'INA81735990'">VEDAM HEALTH CARE</p>
            <p v-else-if="poOrder.agent === 'INA82728817'">AJIT ENTERPRISE</p>
            <p v-else-if="poOrder.agent === 'INA83069158'">DEAR AGENCY</p>
            <p v-else-if="poOrder.agent === 'INA87179169'">WELL LIFE</p>
            <p v-else-if="poOrder.agent === 'INA86665570'">MATTEI SPAGYRIC BIOSCIENCE PRIVATE LIMITED</p>
            <p v-else-if="poOrder.agent === 'INA81626303'">Skymorn Herbs And Dyes Exports</p>
            <p v-else-if="poOrder.agent === 'INA85666830'">Priya Enterprises</p>
            <p v-else-if="poOrder.agent === 'INA80595762'">VINO ENTERPRISE</p>
            <p v-else-if="poOrder.agent === 'INA85988609'">VIJAYA HEALTH PRODUCT</p>
            <p v-else-if="poOrder.agent === 'INA83926859'">M/S SMS FURNITURE</p>
            <p v-else-if="poOrder.agent === 'INA88711883'">Health Harmony</p>
            <p v-else-if="poOrder.agent === 'INA86501281'">POOJA ENTERPRISES</p>
            <p v-else-if="poOrder.agent === 'INA87727262'">THE KAMNA HEALTH PRODUCTS</p>
            <p v-else-if="poOrder.agent === 'INA87076392'">KHALSA STORES</p>
            <p v-else-if="poOrder.agent === 'INA88019922'">AAMIT ENTERPRISES</p>
            <p v-else-if="poOrder.agent === 'INA81235361'">JOHN LALBIAKHLUNA</p>
            <p v-else-if="poOrder.agent === 'INA82879959'">BLUEBELLS STORE ENETERPRISES</p>
            <p v-else-if="poOrder.agent === 'INA88216113'">NATURAL</p>
            <p v-else-if="poOrder.agent === 'INA83360157'">UNBEATABLE WELLNESS</p>
            <p v-else-if="poOrder.agent === 'INA81193993'">MAGANDHA ENTERPRISES</p>
            <p v-else-if="poOrder.agent === 'INA85297558'">MAHALAXMI TRADERS</p>
            <p v-else-if="poOrder.agent === 'INA83206610'">COSMIC INNOVATIONS</p>
            <p v-else-if="poOrder.agent === 'INA86128155'">NAGPUR HEALTH PRODUCTS</p>
            <p v-else-if="poOrder.agent === 'INA81575721'">Global Wellness Enterprise</p>
            <p v-else-if="poOrder.agent === 'INA83677626'">Eagle Enterprise</p>
            <p v-else-if="poOrder.agent === 'INA80589327'">AFRA HEALTHCARE</p>
            <p v-else-if="poOrder.agent === 'INA86957970'">MAAMM GROUP SERVICES</p>
            <p v-else-if="poOrder.agent === 'INA80800130'">SANA</p>
            <p v-else-if="poOrder.agent === 'INA82651850'">CHANDA AYURVEDIC PVT LTD</p>
            <p v-else-if="poOrder.agent === 'INA83213511'">M/S MADHURIYA ENTERPRISE</p>
            <p v-else-if="poOrder.agent === 'INA80691786'">SACHI VARAHI ENTERPRISES</p>
            <p v-else-if="poOrder.agent === 'INA83056800'">HOLY CARE</p>
            <p v-else>FOHOWAY INDIA PRIVATE LIMITED</p>
          </td>
        </tr>
        <tr><td colspan="9"><p>	</p></td></tr>
        <tr><td colspan="9"><p>	</p></td></tr>
        <tr><td colspan="8" style="text-align: right;">Authorised Signatory</td><td></td></tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
import html2canvas from 'html2canvas'
import {poOrderViewprint1} from "@/api/ay-business-manager/orderquery";
//引入插件
export default {
  name: 'PrintDetails',
  data(){
    return{
      id:'',
      poOrder:{},
      miMember:{},
      HSNTotal:{},
      Listdetails:[],
      ListHSN:[],
      status:{},
      listQuery:{}
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getList()
  },
  methods:{
    getList(){
      poOrderViewprint1({id:this.id}).then(res=>{
        this.poOrder = res.data.poOrder
        this.HSNTotal = res.data.hSNTotal
        this.miMember = res.data.miMember
        this.listQuery.benbang = res.data.benbang
        this.listQuery.addressqben = res.data.addressqben
        this.listQuery.addressq = res.data.addressq
        this.Listdetails = res.data.listdetails
        this.listQuery.AmountTotal = res.data.amountTotal
        this.listQuery.CGSTTotal = res.data.cGSTTotal
        this.listQuery.SGSTTotal = res.data.sGSTTotal
        this.listQuery.RoundOff = res.data.roundOff
        this.listQuery.RateTotal = res.data.rateTotal
        this.listQuery.RateTotalEn = res.data.rateTotalEn
        this.listQuery.Invoice = res.data.invoice
        this.listQuery.createTime2 = res.data.createTime2
        this.ListHSN = res.data.listHSN
      }).catch(err=>{
        console.error(err)
      })
    },
    BtnPrint() {
      const print = document.getElementById('print_Id')
      document.body.innerHTML = print.innerHTML
      document.body.style.height = '75%'
      window.print()
      location.reload()
    },
    DownLoad(){
      this.BtnDownload()
    },
    BtnDownload() {
      //页面转成图片
      html2canvas(document.getElementById('print_Id')).then(canvas => {
        this.imgUrl = canvas.toDataURL('image/png') // 可将 canvas 转为 base64 格式
      })
      this.downloadIamge(this.imgUrl, 'pic')
    },
    //不同源下载问题
    downloadIamge(imgsrc, name) { // 下载图片地址和图片名
      var image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function() {
        var canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        var context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        var url = canvas.toDataURL('image/png') // 得到图片的base64编码数据

        var a = document.createElement('a') // 生成一个a元素
        var event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc
    },
  }
}
</script>

<style scoped lang="scss">
table {
  margin: 20px 0 20px 0px;
  width: 100%;
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  tr {
    th {
      width: 150px;
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      border: 1px solid black;
    }
    td {
      width: 200px;
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      border: 1px solid black;
    }
  }
  thead {
    th {
      font-size: 18px;
      border-right: 1px solid black;
      width: 400px;
    }
  }
  tbody {
    td {
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      font-size: 14px;
      border: 1px solid black;
      width: 200px;
    }
  }
}
</style>
